// src/translations/about.js
export default {
  en: {
    section_title: "About Me",
    section_subtitle: "Get to Know Me",
    about_intro: "I'm a real estate professional with a passion for connecting people with their perfect property. Whether you're looking to buy your dream home, sell your property at the best price, or invest in buildable land, I'm here to guide you with expertise, transparency, and genuine care for your success.",
    
    mission_title: "My Approach",
    mission_text: "I believe real estate is more than transactions—it's about understanding your vision and making it reality. I listen carefully to your needs, analyze the market with precision, and present only the best opportunities. My goal is always to exceed expectations with transparency and dedication.",
    
    sectors_title: "What I Do",
    sector1_title: "Looking for a Home?",
    sector1_desc: "I help you find the perfect property that matches your lifestyle and budget. From historic villas to modern apartments, I know the market deeply and guide you toward the right choice.",
    
    sector2_title: "Ready to Sell?",
    sector2_desc: "Selling your property? I handle everything—market evaluation, professional marketing, property showings, and negotiations to get you the best result.",
    
    sector3_title: "Real Estate Investment?",
    sector3_desc: "Looking for buildable land or investment opportunities? I identify profitable properties with thorough market analysis and strategic insights.",

    process_title: "How It Works",
    process_step1_title: "Initial Consultation",
    process_step1_desc: "We start with a detailed conversation about your needs, budget, timeline, and goals. This is where I understand what truly matters to you.",
    
    process_step2_title: "Market Research",
    process_step2_desc: "I analyze the market thoroughly, identify suitable opportunities, and prepare a personalized selection tailored to your requirements.",
    
    process_step3_title: "Property Viewing",
    process_step3_desc: "We visit selected properties together. I provide detailed insights about each property, the neighborhood, and investment potential.",
    
    process_step4_title: "Closing & Support",
    process_step4_desc: "I guide you through negotiations, documentation, and closing. My support continues even after the sale or purchase is complete.",
  },
  it: {
    section_title: "Chi Sono",
    section_subtitle: "Conoscimi",
    about_intro: "Sono una professionista immobiliare con una passione genuina nel connettere le persone con la proprietà perfetta. Che tu stia cercando la casa dei tuoi sogni, voglia vendere la tua proprietà al miglior prezzo, o investire in terreni edificabili, sono qui per guidarti con competenza, trasparenza e dedizione vera al tuo successo.",
    
    mission_title: "Il Mio Metodo",
    mission_text: "Credo che l'immobiliare sia più che transazioni—è comprendere la tua visione e renderla realtà. Ascolto attentamente le tue esigenze, analizzo il mercato con precisione e ti presento solo le migliori opportunità. Il mio obiettivo è sempre superare le aspettative con trasparenza e dedizione.",
    
    sectors_title: "Cosa Faccio",
    sector1_title: "Cerchi una Casa?",
    sector1_desc: "Ti aiuto a trovare la proprietà perfetta che rispecchia il tuo stile di vita e budget. Dalle ville storiche agli appartamenti moderni, conosco profondamente il mercato e ti guido verso la scelta giusta.",
    
    sector2_title: "Vuoi Vendere?",
    sector2_desc: "Vendere la tua proprietà? Mi occupo di tutto: valutazione di mercato, marketing professionale, visite, trattative per ottenere il miglior risultato.",
    
    sector3_title: "Investimenti Immobiliari?",
    sector3_desc: "Cerchi terreni edificabili o opportunità di investimento? Identifico proprietà redditizie con analisi di mercato approfondita e insights strategici.",

    process_title: "Come Funziona",
    process_step1_title: "Consulenza Iniziale",
    process_step1_desc: "Iniziamo con una conversazione dettagliata sulle tue esigenze, budget, tempi e obiettivi. È qui che comprendo veramente cosa conta per te.",
    
    process_step2_title: "Ricerca di Mercato",
    process_step2_desc: "Analizzo il mercato accuratamente, identifico opportunità adatte e preparo una selezione personalizzata in base alle tue esigenze.",
    
    process_step3_title: "Visita Proprietà",
    process_step3_desc: "Visitiamo insieme le proprietà selezionate. Ti fornisco insights dettagliati su ogni proprietà, il quartiere e il potenziale di investimento.",
    
    process_step4_title: "Chiusura e Supporto",
    process_step4_desc: "Ti guido attraverso negoziazioni, documentazione e chiusura. Il mio supporto continua anche dopo la vendita o l'acquisto.",
  }
};